import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Button, mergeClasses } from '@fluentui/react-components';
import {
  DrawerOverlay,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  DrawerFooter,
} from '@fluentui/react-drawer';
import { usePanelStyle } from '../../styles';

export const ItemDetailsPanelBase = ({
  dismiss,
  isOpen,
  onRenderHeader,
  i18n,
  children,
  footerKeyDownHandler,
}) => {
  const classes = usePanelStyle();

  const onFooterKeyDown = useCallback((event) => {
    if (_.isFunction(footerKeyDownHandler)) {
      footerKeyDownHandler(event);
    }
  }, [footerKeyDownHandler]);

  const onRenderFooterContent = useCallback(
    () => (
      <div className={classes.footer}>
        <Button title={i18n.getString(_TL_('Done'))} className={mergeClasses('done-button', classes.footerButton)} onClick={dismiss} onKeyDown={onFooterKeyDown}>{i18n.getString(_TL_('Done'))}</Button>
      </div>
    ),
    [classes.footer, classes.footerButton, dismiss, i18n, onFooterKeyDown]
  );

  return (
    <DrawerOverlay
      open={isOpen}
      modalType="non-modal"
      position="end"
      className={classes.detailPanel}
    >
      <div className="ads-studio-detail-panel" style={{ width: '100%' }}>
        <DrawerHeader className={classes.header}>
          <DrawerHeaderTitle>
            {onRenderHeader}
          </DrawerHeaderTitle>
        </DrawerHeader>
      </div>
      <DrawerBody className={classes.content}>
        {children}
      </DrawerBody>
      <DrawerFooter>
        {onRenderFooterContent}
      </DrawerFooter>
    </DrawerOverlay>
  );
};

ItemDetailsPanelBase.propTypes = {
  dismiss: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onRenderHeader: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  children: PropTypes.element,
  footerKeyDownHandler: PropTypes.func,
};

ItemDetailsPanelBase.defaultProps = {
  isOpen: false,
  children: null,
  footerKeyDownHandler: _.noop,
};
